import { useState, useEffect } from "react"
import axios from "axios"

const useParentCategories = () => {
  const [categories, setCategories] = useState([])
  const [loading, setloading] = useState(true)

  const getCategories = async () => {
    const url = `${process.env.GATSBY_API_URL}/wp-json/wc/v3/products/categories?consumer_key=${process.env.GATSBY_CONSUMER_KEY}&consumer_secret=${process.env.GATSBY_CONSUMER_SECRET}&parent=0`

    axios
      .get(url)
      .then(({ data }) => {
        setCategories(data)
      })
      .catch(error => {
        // handle error
        console.log(error)
        setloading(false)
      })
  }

  useEffect(() => {
    getCategories()
  }, [])
  return { categories, loading }
}

export default useParentCategories
